import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import type { HttpStatusCode } from '@angular/common/http';

type StatusWithoutNoContent = Exclude<HttpStatusCode, HttpStatusCode.NoContent>;

export function assertBody<T>(
  response: (HttpResponse<T> & { status: StatusWithoutNoContent }) | (HttpErrorResponse & { error: T | null })
): T {
  if (response instanceof HttpResponse) {
    return response.body!;
  } else if (response instanceof HttpErrorResponse) {
    return response.error;
  } else {
    throw new Error('Response body is empty.');
  }
}
